module.exports = __webpack_public_path__ + "img/private_event_wedding2.db01ddc7.jpg";